import { Link } from "react-router-dom";
import { siteMeta, stats } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full flex-col justify-center overflow-hidden md:min-h-[700px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dramatic%20empty%20theatre%20stage%20with%20warm%20amber%20spotlight%20beams%20cutting%20through%20haze%2C%20deep%20crimson%20velvet%20curtains%2C%20cinematic%20moody%20atmosphere%2C%20no%20people%2C%20editorial%20photography%2C%20rich%20shadows%20and%20glowing%20highlights&width=1600&height=900&seq=gua-hero-01&orientation=landscape"
          alt="剧院舞台暖色聚光灯氛围图，象征事件复盘的档案现场"
          title="独家吃瓜 事件复盘 档案现场"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/85"></div>
      </div>

      <div className="container-x relative z-10 w-full pt-28 pb-16 md:pt-32 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-accent-500/15 px-3 py-1.5 text-xs font-medium text-accent-200">
            <i className="ri-flashlight-line"></i>
            2026 年第 36 期档案已更新
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-background-50 md:text-6xl">
            独家吃瓜
          </h1>

          <p className="mt-5 max-w-2xl font-heading text-xl font-semibold leading-relaxed text-accent-200 md:text-2xl">
            把一件事的来龙去脉，按顺序讲清楚
          </p>

          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base md:leading-8">
            深扒内幕、复盘真相、梳理细节线索。我们不追标题，只把散落各处的碎片信息重新拼成一条能读懂的线：先发生了什么，各方什么时候回应，哪些细节对不上。
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-2-line"></i>
              浏览全部事件档案
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-shield-check-line"></i>
              我们的内容原则
            </Link>
          </div>

          <dl className="mt-12 grid grid-cols-2 gap-x-6 gap-y-6 border-t border-background-50/20 pt-8 md:grid-cols-4">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</dt>
                <dd className="mt-1 text-xs leading-5 text-background-300">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <p className="absolute bottom-4 right-5 z-10 hidden text-[11px] tracking-widest text-background-400 md:block">
        {siteMeta.slogan}
      </p>
    </section>
  );
}